export function buildDesignSystemContext(projectName: string) {
  return { projectName };
}
